/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStammdatenDto } from '../../models/lexplus-stammdaten-dto';
import { LexplusStammdatenTyp } from '../../models/lexplus-stammdaten-typ';

export interface StammdatenControllerFindAllV1$Params {
  typ: LexplusStammdatenTyp;
}

export function stammdatenControllerFindAllV1(http: HttpClient, rootUrl: string, params: StammdatenControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusStammdatenDto>>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerFindAllV1.PATH, 'get');
  if (params) {
    rb.path('typ', params.typ, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusStammdatenDto>>;
    })
  );
}

stammdatenControllerFindAllV1.PATH = '/v1/stammdaten/all/{typ}';
